import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=cf437de2&scoped=true&"
import script from "./curriculum.vue?vue&type=script&lang=js&"
export * from "./curriculum.vue?vue&type=script&lang=js&"
import style0 from "./curriculum.vue?vue&type=style&index=0&lang=css&"
import style1 from "./curriculum.vue?vue&type=style&index=1&id=cf437de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf437de2",
  null
  
)

export default component.exports